import './ccf-plus-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfPlusIconProps extends SvgIconProps {
  fillColor?: string;
}

/**
 * CcfPlusIcon used to disply plus icon in the contact card channel panel
 * @param props - CcfPlusIconProps
 * @example -- <CcfPlusIcon />
 */
export function CcfPlusIcon(props: CcfPlusIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="ic_Add_Channel"
        data-name="ic_Add Channel"
        clipPath="url(#clip-ic_Add_Channel)"
      >
        <g
          id="Group_119869"
          data-name="Group 119869"
          transform="translate(-3 -3)"
          opacity="0.853"
        >
          <rect
            id="Rectangle_37572"
            data-name="Rectangle 37572"
            width="36"
            height="36"
            transform="translate(-3 -3)"
            fill="gray"
            opacity="0"
          />
          <path
            id="plus"
            d="M19.2,10.2h-7v-7h-2v7h-7v2h7v7h2v-7h7Z"
            transform="translate(3.8 3.801)"
            fill={props?.fillColor ? props.fillColor : '  #526b7a'}
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfPlusIcon;
